import React, { FC, useCallback, useEffect, useState } from 'react'
import { useEmblaCarousel } from 'embla-carousel-react'
import Box from '@components/Box'
import { IStep, steps } from '@components/HowToParticipate/data'
import { SStep, SSubTitle, SText } from '@components/HowItWorksOnAero/SComponents'
import { SNumber } from '@components/HowToGet/Steps'
import { colors } from '@styles/theme'
import Arrow from '@icons/stepArrow.inline.svg'
import { SWideButton } from '@components/Benefits/Card'
import { DotButton } from '@components/Benefits/Benefits'

const WithSlider: FC = () => {
  const sliderSettings = {
    loop: false,
    slidesToScroll: 1,
    align: 'start',
    speed: 20,
  }

  const [Slider, slider] = useEmblaCarousel(sliderSettings)
  const [selectedIndex, setSelectedIndex] = useState(0)

  const onSelect = useCallback(() => {
    if (slider) {
      setSelectedIndex(slider.selectedScrollSnap())
    }
  }, [slider])

  const scrollTo = useCallback(
    (index: number): void => {
      if (slider) {
        slider.scrollTo(index)
      }
    },
    [slider],
  )

  useEffect(() => {
    if (slider) {
      slider.on('select', onSelect)
      onSelect()
    }
  }, [slider, onSelect])

  return (
    <Slider className="slider">
      <Box display="flex">
        {steps.map(({ heading, content, link }: IStep, index) => (
          <SStep key={index}>
            <Box display="flex" alignItems="center" mb="12px">
              <SNumber color={colors.darkBlue}>{index + 1}</SNumber>
              {index !== steps.length - 1 && <Arrow />}
            </Box>
            <SSubTitle>{heading}</SSubTitle>
            <SText>{content}</SText>
            {link && (
              <SWideButton href={link.url} link mt={{ _: 'auto' }} color={colors.darkBlue}>
                {link.text}
              </SWideButton>
            )}
          </SStep>
        ))}
      </Box>
      <Box display="flex" mt="20px" justifyContent="center">
        {steps.map((_, index) => (
          <DotButton
            key={index}
            selected={index === selectedIndex}
            color={colors.darkBlue}
            onClick={() => scrollTo(index)}
          />
        ))}
      </Box>
    </Slider>
  )
}

export default WithSlider
